import axios from 'axios';
import { API_BASE_URL } from './config';

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Critical: enables sending cookies (admin_token) with requests
});

// Request interceptor to set Content-Type only for non-FormData requests
api.interceptors.request.use(
  (config) => {
    // Don't set Content-Type for FormData - browser will set it automatically with boundary
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login on 401 if we're not already on the login page
    // This prevents redirect loops during login attempts
    // Don't auto-redirect for mutations - let them handle errors themselves
    const isMutationRequest = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(error.config?.method?.toUpperCase() || '');
    
    // Don't redirect to login on 401 if we're on public pages (login, forgot-password, reset-password)
    const isPublicPage = window.location.pathname.includes('/login') || 
                         window.location.pathname.includes('/forgot-password') ||
                         window.location.pathname.includes('/reset-password');
    
    if (
      error.response?.status === 401 && 
      !isPublicPage &&
      !isMutationRequest // Don't auto-redirect for mutations, let them handle errors
    ) {
      // Unauthorized - admin_token is invalid or missing
      // Clear localStorage (admin_user is just for UI, not auth)
      // admin_token cookie is httpOnly, so we can't clear it from JS
      // Backend will handle clearing it on logout
      localStorage.removeItem('admin_user');
      
      // Redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

